// frontend/src/features/meetings/components/MeetingsKpiStrip.js
import React from 'react';
import { isMeetingPast, getEffectiveMeetingStatus } from '../api/meetingsApi';

const formatDateKey = (d) => {
  if (!d) return '';
  const dateObj = typeof d === 'string' ? new Date(d) : d;
  if (isNaN(dateObj.getTime())) return '';
  const y = dateObj.getFullYear();
  const m = String(dateObj.getMonth() + 1).padStart(2, '0');
  const day = String(dateObj.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
};

export default function MeetingsKpiStrip({ meetings = [] }) {
  const todayStr = formatDateKey(new Date());

  const meetingsToday = meetings.filter((m) => {
    return m.startTime && formatDateKey(m.startTime) === todayStr && m.status !== 'cancelled';
  });

  const upcomingCount = meetings.filter(
    (m) =>
      (getEffectiveMeetingStatus(m) === 'confirmed' ||
        getEffectiveMeetingStatus(m) === 'in_progress') &&
      !isMeetingPast(m)
  ).length;
  const needsRecapCount = meetings.filter(
    (m) => getEffectiveMeetingStatus(m) === 'needs_recap'
  ).length;
  const completedCount = meetings.filter(
    (m) => getEffectiveMeetingStatus(m) === 'completed'
  ).length;

  const kpis = [
    {
      label: 'Scheduled Today',
      value: meetingsToday.length,
      icon: 'fas fa-calendar-day',
    },
    {
      label: 'Upcoming Calls',
      value: upcomingCount,
      icon: 'fas fa-video',
    },
    {
      label: 'Needs Recap',
      value: needsRecapCount,
      icon: 'fas fa-clipboard-check',
    },
    {
      label: 'Completed Calls',
      value: completedCount,
      icon: 'fas fa-check-circle',
    },
  ];

  return (
    <div className="meetings-kpi-strip">
      {kpis.map((kpi, idx) => (
        <div key={idx} className="meetings-kpi-card">
          <div className="meetings-kpi-info">
            <span className="meetings-kpi-label">{kpi.label}</span>
            <span className="meetings-kpi-number">{kpi.value}</span>
          </div>
          <div className="meetings-kpi-icon-simple">
            <i className={kpi.icon} />
          </div>
        </div>
      ))}
    </div>
  );
}
